(function() {
  'use strict';

  /* Guard: this file is loaded by the header (garage chip) AND by product/cart
     snippets. Only initialize once per page. */
  if (window.__oemFitmentInit) return;
  window.__oemFitmentInit = true;

  var API_BASE = 'https://fitment-api.oempartsdepartment.com/fitment';
  /* Canonical vehicle storage key ("My Garage"). */
  var STORAGE_KEY = 'oem_garage_vehicle';
  /* Old key kept for back-compat: migrated on read, mirrored on write. */
  var LEGACY_KEY = 'oem_fitment_vehicle';

  var state = {
    make: null,
    model: null,
    year: null,
    sub_model: null
  };

  function getWidget() {
    return document.getElementById('fitment-widget');
  }

  function isCartMode() {
    var widget = getWidget();
    return widget && widget.dataset.mode === 'cart';
  }

  function getEl(id) {
    return document.getElementById('fitment-' + id);
  }

  function api(path, params) {
    var url = new URL(API_BASE + path);
    if (params) {
      Object.keys(params).forEach(function(k) {
        if (params[k]) url.searchParams.set(k, params[k]);
      });
    }
    return fetch(url.toString()).then(function(res) {
      if (!res.ok) throw new Error('API error: ' + res.status);
      return res.json();
    });
  }

  function saveVehicle() {
    try {
      var data = JSON.stringify(state);
      localStorage.setItem(STORAGE_KEY, data);
      localStorage.setItem(LEGACY_KEY, data);
    } catch (e) {}
    renderGarageChip();
  }

  function loadVehicle() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved) return JSON.parse(saved);
      /* Migrate legacy key transparently. */
      var legacy = localStorage.getItem(LEGACY_KEY);
      if (legacy) {
        localStorage.setItem(STORAGE_KEY, legacy);
        return JSON.parse(legacy);
      }
    } catch (e) {}
    return null;
  }

  function clearVehicle() {
    state.make = null;
    state.model = null;
    state.year = null;
    state.sub_model = null;
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(LEGACY_KEY);
    } catch(e) {}
    renderGarageChip();
  }

  function populateSelect(el, options, placeholder) {
    el.innerHTML = '<option value="">' + placeholder + '</option>';
    options.forEach(function(opt) {
      var o = document.createElement('option');
      o.value = opt;
      o.textContent = opt;
      el.appendChild(o);
    });
    el.disabled = false;
  }

  function disableSelect(el, placeholder) {
    el.innerHTML = '<option value="">' + placeholder + '</option>';
    el.disabled = true;
  }

  function showStatus(msg, type) {
    var el = getEl('status');
    if (!el) return;
    el.textContent = msg;
    el.className = 'fitment-status fitment-status--' + (type || 'info');
    el.style.display = msg ? 'block' : 'none';
  }

  function showSelectedBanner() {
    var banner = getEl('selected-banner');
    var form = getEl('form');
    if (!banner || !form) return;

    if (state.make && state.model && state.year) {
      var parts = [state.year, state.make, state.model];
      if (state.sub_model) parts.push(state.sub_model);
      banner.querySelector('.fitment-selected__text').textContent = parts.join(' ');
      banner.style.display = 'flex';
      form.style.display = 'none';
    } else {
      banner.style.display = 'none';
      form.style.display = 'grid';
    }
  }

  function dispatchVehicleEvent() {
    if (!isCartMode()) return;
    if (state.make && state.model && state.year) {
      document.dispatchEvent(new CustomEvent('fitment:vehicle-selected', {
        detail: { make: state.make, model: state.model, year: state.year, sub_model: state.sub_model || '' }
      }));
    }
  }

  function dispatchClearEvent() {
    if (!isCartMode()) return;
    document.dispatchEvent(new CustomEvent('fitment:vehicle-cleared'));
  }

  function loadMakes() {
    var sel = getEl('make');
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    api('/makes').then(function(data) {
      populateSelect(sel, data.makes, 'Select Make');
    }).catch(function(e) {
      console.error('Failed to load makes:', e);
      disableSelect(sel, 'Error loading makes');
    });
  }

  function loadModels(make) {
    var sel = getEl('model');
    disableSelect(getEl('year'), 'Select Year');
    disableSelect(getEl('sub_model'), 'Select Sub-Model');
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    api('/models', { make: make }).then(function(data) {
      populateSelect(sel, data.models, 'Select Model');
    }).catch(function(e) {
      console.error('Failed to load models:', e);
      disableSelect(sel, 'Error loading models');
    });
  }

  function loadYears(make, model) {
    var sel = getEl('year');
    disableSelect(getEl('sub_model'), 'Select Sub-Model');
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    api('/years', { make: make, model: model }).then(function(data) {
      populateSelect(sel, data.years, 'Select Year');
    }).catch(function(e) {
      console.error('Failed to load years:', e);
      disableSelect(sel, 'Error loading years');
    });
  }

  function loadSubModels(make, model, year) {
    var sel = getEl('sub_model');
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    api('/sub_models', { make: make, model: model, year: year }).then(function(data) {
      if (data.sub_models && data.sub_models.length > 0) {
        populateSelect(sel, data.sub_models, 'Select Sub-Model');
      } else {
        disableSelect(sel, 'No sub-models');
        state.sub_model = '__none__';
        dispatchVehicleEvent();
        validateFitment();
        validateCollectionCards();
      }
    }).catch(function(e) {
      console.error('Failed to load sub-models:', e);
      disableSelect(sel, 'Error loading sub-models');
    });
  }

  function getCartSkus() {
    if (window.__cart_skus && window.__cart_skus.length > 0) {
      return window.__cart_skus.filter(function(s, i, arr) { return arr.indexOf(s) === i; });
    }
    return [];
  }

  function getCartItemName(sku) {
    if (window.__cart_items_info) {
      var item = window.__cart_items_info.find(function(i) { return i.sku === sku; });
      if (item) return item.title;
    }
    return sku;
  }

  function updateGalleryVehicleContext(vehicleName, fits) {
    var banner = document.getElementById('gallery-vehicle-context');
    if (!banner) return;
    if (!vehicleName) {
      banner.style.display = 'none';
      banner.className = 'gallery-vehicle-context';
      return;
    }
    banner.style.display = 'flex';
    if (fits) {
      banner.className = 'gallery-vehicle-context gallery-vehicle-context--fits';
      banner.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' +
        '<span>Showing parts for your <strong>' + vehicleName + '</strong></span>';
    } else {
      banner.className = 'gallery-vehicle-context gallery-vehicle-context--nofit';
      banner.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '<span>This part may not fit your <strong>' + vehicleName + '</strong></span>';
    }
  }

  function updateCollectionCards(validSkus) {
    var cards = document.querySelectorAll('[data-product-sku]');
    if (!cards.length) return;
    cards.forEach(function(card) {
      var sku = card.dataset.productSku;
      var badge = card.querySelector('.fitment-card-badge');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'fitment-card-badge';
        var mediaEl = card.querySelector('.card__media');
        if (mediaEl) mediaEl.style.position = 'relative';
        (mediaEl || card).appendChild(badge);
      }
      if (validSkus === null) {
        badge.style.display = 'none';
      } else if (validSkus.indexOf(sku) !== -1) {
        badge.style.display = 'flex';
        badge.className = 'fitment-card-badge fitment-card-badge--fits';
        badge.innerHTML = '✓ Fits';
      } else {
        badge.style.display = 'flex';
        badge.className = 'fitment-card-badge fitment-card-badge--nofit';
        badge.innerHTML = '✗ May not fit';
      }
    });
  }

  function validateFitment() {
    if (!state.make || !state.model || !state.year) return;

    var widget = getWidget();
    if (!widget) return;

    var variantSkus = [];

    if (isCartMode()) {
      variantSkus = getCartSkus();
    } else {
      var skuAttr = widget.dataset.productSku;
      if (skuAttr) variantSkus.push(skuAttr);

      if (window.__fitment_skus && window.__fitment_skus.length > 0) {
        window.__fitment_skus.forEach(function(s) {
          if (s && variantSkus.indexOf(s) === -1) variantSkus.push(s);
        });
      }
    }

    if (variantSkus.length === 0) {
      showStatus('', 'info');
      return;
    }

    var vehicleName = state.year + ' ' + state.make + ' ' + state.model;
    showStatus('Checking fitment...', 'info');

    fetch(API_BASE + '/validate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        year: state.year,
        make: state.make,
        model: state.model,
        sub_model: state.sub_model || undefined,
        skus: variantSkus
      })
    }).then(function(res) {
      return res.json();
    }).then(function(result) {
      if (result.results) {
        if (isCartMode()) {
          renderCartResults(result.results, vehicleName);
        } else {
          var match = result.results.find(function(r) { return r.valid; });
          if (match) {
            var msg = '✅ This part fits your ' + vehicleName;
            if (match.engine) msg += ' (' + match.engine + ')';
            showStatus(msg, 'success');
            updateGalleryVehicleContext(vehicleName, true);
          } else {
            showStatus('⚠️ This part may not fit your ' + vehicleName + '. Please verify before purchasing.', 'warning');
            updateGalleryVehicleContext(vehicleName, false);
          }
          var validSkus = result.results.filter(function(r) { return r.valid; }).map(function(r) { return r.sku; });
          updateCollectionCards(validSkus);
        }
      }
    }).catch(function(e) {
      console.error('Fitment validation error:', e);
      showStatus('Unable to verify fitment. Please try again.', 'info');
    });
  }

  function renderCartResults(results, vehicleName) {
    var resultsEl = document.getElementById('cart-fitment-results');
    if (!resultsEl) {
      showStatus('', 'info');
      return;
    }

    var allFit = results.every(function(r) { return r.valid; });
    var anyFit = results.some(function(r) { return r.valid; });

    if (allFit) {
      showStatus('✅ All items in your cart fit your ' + vehicleName, 'success');
    } else if (!anyFit) {
      showStatus('⚠️ Items in your cart may not fit your ' + vehicleName + '. Please verify before purchasing.', 'warning');
    } else {
      showStatus('Some items may not fit your ' + vehicleName + '. See details below.', 'warning');
    }

    if (results.length > 1) {
      var html = '';
      results.forEach(function(r) {
        if (r.valid) {
          html += '<div class="cart-fitment__item cart-fitment__item--fit">';
          html += '<span class="cart-fitment__item-icon">✅</span>';
          html += '<span class="cart-fitment__item-name">' + getCartItemName(r.sku) + '</span>';
          if (r.engine) html += '<span>(' + r.engine + ')</span>';
          html += '</div>';
        } else {
          html += '<div class="cart-fitment__item cart-fitment__item--nofit">';
          html += '<span class="cart-fitment__item-icon">⚠️</span>';
          html += '<span class="cart-fitment__item-name">' + getCartItemName(r.sku) + ' — may not fit</span>';
          html += '</div>';
        }
      });
      resultsEl.innerHTML = html;
    } else {
      resultsEl.innerHTML = '';
    }
  }

  function bindEvents() {
    var makeEl = getEl('make');
    var modelEl = getEl('model');
    var yearEl = getEl('year');
    var subEl = getEl('sub_model');
    var changeBtn = getEl('change-btn');

    if (makeEl) {
      makeEl.addEventListener('change', function() {
        state.make = this.value || null;
        state.model = null;
        state.year = null;
        state.sub_model = null;
        if (state.make) {
          loadModels(state.make);
        } else {
          disableSelect(modelEl, 'Select Model');
          disableSelect(yearEl, 'Select Year');
          disableSelect(subEl, 'Select Sub-Model');
        }
        showStatus('', 'info');
        saveVehicle();
        showSelectedBanner();
      });
    }

    if (modelEl) {
      modelEl.addEventListener('change', function() {
        state.model = this.value || null;
        state.year = null;
        state.sub_model = null;
        if (state.make && state.model) {
          loadYears(state.make, state.model);
        } else {
          disableSelect(yearEl, 'Select Year');
          disableSelect(subEl, 'Select Sub-Model');
        }
        showStatus('', 'info');
        saveVehicle();
        showSelectedBanner();
      });
    }

    if (yearEl) {
      yearEl.addEventListener('change', function() {
        state.year = this.value || null;
        state.sub_model = null;
        if (state.make && state.model && state.year) {
          loadSubModels(state.make, state.model, state.year);
          saveVehicle();
          showSelectedBanner();
        } else {
          disableSelect(subEl, 'Select Sub-Model');
        }
        showStatus('', 'info');
      });
    }

    if (subEl) {
      subEl.addEventListener('change', function() {
        state.sub_model = this.value || null;
        saveVehicle();
        dispatchVehicleEvent();
        validateFitment();
        validateCollectionCards();
      });
    }

    if (changeBtn) {
      changeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        clearVehicle();
        resetWidgetUI();
        dispatchClearEvent();
      });
    }
  }

  /* Reset the embedded #fitment-widget (product/cart) back to its empty state.
     Safe to call on pages without the widget. */
  function resetWidgetUI() {
    var widget = getWidget();
    if (!widget) return;
    disableSelect(getEl('model'), 'Select Model');
    disableSelect(getEl('year'), 'Select Year');
    disableSelect(getEl('sub_model'), 'Select Sub-Model');
    showStatus('', 'info');
    var resultsEl = document.getElementById('cart-fitment-results');
    if (resultsEl) resultsEl.innerHTML = '';
    showSelectedBanner();
    updateGalleryVehicleContext(null);
    updateCollectionCards(null);
    loadMakes();
  }

  function restoreSaved() {
    var saved = loadVehicle();
    if (!saved || !saved.make) return;

    Object.assign(state, saved);

    var makeEl = getEl('make');
    var modelEl = getEl('model');
    var yearEl = getEl('year');
    var subEl = getEl('sub_model');

    api('/makes').then(function(data) {
      populateSelect(makeEl, data.makes, 'Select Make');
      if (state.make) {
        makeEl.value = state.make;
        return api('/models', { make: state.make });
      }
    }).then(function(data) {
      if (data && data.models) {
        populateSelect(modelEl, data.models, 'Select Model');
        if (state.model) {
          modelEl.value = state.model;
          return api('/years', { make: state.make, model: state.model });
        }
      }
    }).then(function(data) {
      if (data && data.years) {
        populateSelect(yearEl, data.years, 'Select Year');
        if (state.year) {
          yearEl.value = state.year;
          return api('/sub_models', { make: state.make, model: state.model, year: state.year });
        }
      }
    }).then(function(data) {
      if (data && data.sub_models && data.sub_models.length > 0) {
        populateSelect(subEl, data.sub_models, 'Select Sub-Model');
        if (state.sub_model) {
          subEl.value = state.sub_model;
        }
      } else if (data) {
        disableSelect(subEl, 'No sub-models');
        state.sub_model = '__none__';
      }
      showSelectedBanner();
      dispatchVehicleEvent();
      validateFitment();
      validateCollectionCards();
    }).catch(function(e) {
      console.error('Error restoring saved vehicle:', e);
      loadMakes();
    });
  }

  function validateCollectionCards() {
    var cards = document.querySelectorAll('[data-product-sku]');
    if (!cards.length || !state.make || !state.model || !state.year) return;

    var skus = [];
    cards.forEach(function(card) {
      var sku = card.dataset.productSku;
      if (sku && skus.indexOf(sku) === -1) skus.push(sku);
    });
    if (!skus.length) return;

    fetch(API_BASE + '/validate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        year: state.year,
        make: state.make,
        model: state.model,
        sub_model: state.sub_model || undefined,
        skus: skus
      })
    }).then(function(res) {
      return res.json();
    }).then(function(result) {
      if (result.results) {
        var validSkus = result.results.filter(function(r) { return r.valid; }).map(function(r) { return r.sku; });
        updateCollectionCards(validSkus);
      }
    }).catch(function(e) {
      console.error('Collection fitment check error:', e);
    });
  }

  /* ==========================================================================
     My Garage — header chip + vehicle picker modal
     Shares state/storage/API helpers with the fitment widget above.
     ========================================================================== */

  var garageSel = { make: null, model: null, year: null, sub_model: null };

  function gEl(id) {
    return document.getElementById('garage-' + id);
  }

  function vehicleLabel(v) {
    var label = v.year + ' ' + v.make + ' ' + v.model;
    if (v.sub_model && v.sub_model !== '__none__') label += ' · ' + v.sub_model;
    return label;
  }

  /* Generic cascading loader reusing api()/populateSelect()/disableSelect(). */
  function loadOptionsInto(sel, path, params, key, placeholder) {
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    return api(path, params).then(function(data) {
      populateSelect(sel, data[key] || [], placeholder);
      return data;
    }).catch(function(e) {
      console.error('Failed to load ' + key + ':', e);
      disableSelect(sel, 'Error loading options');
      throw e;
    });
  }

  function renderGarageChip() {
    var chip = document.getElementById('garage-chip');
    if (!chip) return;
    var emptyEl = document.getElementById('garage-chip-empty');
    var vehicleEl = document.getElementById('garage-chip-vehicle');
    var textEl = document.getElementById('garage-chip-vehicle-text');
    if (!emptyEl || !vehicleEl || !textEl) return;

    var v = loadVehicle();
    if (v && v.make && v.model && v.year) {
      textEl.textContent = vehicleLabel(v);
      textEl.title = vehicleLabel(v);
      emptyEl.style.display = 'none';
      vehicleEl.style.display = 'inline-flex';
      chip.classList.add('garage-chip--has-vehicle');
    } else {
      emptyEl.style.display = 'inline-flex';
      vehicleEl.style.display = 'none';
      chip.classList.remove('garage-chip--has-vehicle');
    }
  }

  function updateGarageSaveBtn() {
    var btn = gEl('save');
    if (!btn) return;
    btn.disabled = !(garageSel.make && garageSel.model && garageSel.year && garageSel.sub_model);
  }

  function loadGarageSubModels() {
    var sel = gEl('sub_model');
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    return api('/sub_models', { make: garageSel.make, model: garageSel.model, year: garageSel.year }).then(function(data) {
      if (data.sub_models && data.sub_models.length > 0) {
        populateSelect(sel, data.sub_models, 'Select Sub-Model');
        garageSel.sub_model = null;
      } else {
        disableSelect(sel, 'No sub-models');
        garageSel.sub_model = '__none__';
      }
      updateGarageSaveBtn();
      return data;
    }).catch(function(e) {
      console.error('Failed to load sub-models:', e);
      disableSelect(sel, 'Error loading options');
    });
  }

  function openGarageModal() {
    var modal = document.getElementById('garage-modal');
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.documentElement.classList.add('garage-modal-open');

    garageSel.make = null;
    garageSel.model = null;
    garageSel.year = null;
    garageSel.sub_model = null;

    disableSelect(gEl('model'), 'Select Model');
    disableSelect(gEl('year'), 'Select Year');
    disableSelect(gEl('sub_model'), 'Select Sub-Model');
    updateGarageSaveBtn();

    var v = loadVehicle();
    loadOptionsInto(gEl('make'), '/makes', null, 'makes', 'Select Make').then(function() {
      if (!v || !v.make) return;
      gEl('make').value = v.make;
      if (gEl('make').value !== v.make) return;
      garageSel.make = v.make;
      return loadOptionsInto(gEl('model'), '/models', { make: v.make }, 'models', 'Select Model').then(function() {
        if (!v.model) return;
        gEl('model').value = v.model;
        if (gEl('model').value !== v.model) return;
        garageSel.model = v.model;
        return loadOptionsInto(gEl('year'), '/years', { make: v.make, model: v.model }, 'years', 'Select Year').then(function() {
          if (!v.year) return;
          gEl('year').value = String(v.year);
          if (gEl('year').value !== String(v.year)) return;
          garageSel.year = v.year;
          return loadGarageSubModels().then(function() {
            if (v.sub_model && v.sub_model !== '__none__' && garageSel.sub_model !== '__none__') {
              gEl('sub_model').value = v.sub_model;
              if (gEl('sub_model').value === v.sub_model) garageSel.sub_model = v.sub_model;
            }
            updateGarageSaveBtn();
          });
        });
      });
    }).catch(function(e) {
      console.error('Garage modal load error:', e);
    });

    var makeSel = gEl('make');
    if (makeSel) makeSel.focus();
  }

  function closeGarageModal() {
    var modal = document.getElementById('garage-modal');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('garage-modal-open');
  }

  function saveGarageVehicle() {
    if (!(garageSel.make && garageSel.model && garageSel.year && garageSel.sub_model)) return;
    state.make = garageSel.make;
    state.model = garageSel.model;
    state.year = garageSel.year;
    state.sub_model = garageSel.sub_model;
    saveVehicle();
    closeGarageModal();

    /* Same event contract as the cart widget; the chip dispatches on every page. */
    document.dispatchEvent(new CustomEvent('fitment:vehicle-selected', {
      detail: { make: state.make, model: state.model, year: state.year, sub_model: state.sub_model || '' }
    }));

    /* Sync any embedded fitment widget on this page. */
    if (getWidget()) restoreSaved();
  }

  function removeGarageVehicle() {
    clearVehicle();
    document.dispatchEvent(new CustomEvent('fitment:vehicle-cleared'));
    resetWidgetUI();
  }

  function bindGarageEvents() {
    var selectBtn = document.getElementById('garage-chip-select');
    var changeBtn = document.getElementById('garage-chip-change');
    var removeBtn = document.getElementById('garage-chip-remove');
    var cancelBtn = gEl('cancel');
    var closeBtn = gEl('modal-close');
    var saveBtn = gEl('save');
    var backdrop = gEl('modal-backdrop');

    if (selectBtn) selectBtn.addEventListener('click', openGarageModal);
    if (changeBtn) changeBtn.addEventListener('click', openGarageModal);
    if (removeBtn) removeBtn.addEventListener('click', removeGarageVehicle);
    if (cancelBtn) cancelBtn.addEventListener('click', closeGarageModal);
    if (closeBtn) closeBtn.addEventListener('click', closeGarageModal);
    if (backdrop) backdrop.addEventListener('click', closeGarageModal);
    if (saveBtn) saveBtn.addEventListener('click', saveGarageVehicle);

    document.addEventListener('keydown', function(e) {
      var modal = document.getElementById('garage-modal');
      if (!modal || modal.hasAttribute('hidden')) return;
      if (e.key === 'Escape' || e.keyCode === 27) closeGarageModal();
    });

    var makeEl = gEl('make');
    var modelEl = gEl('model');
    var yearEl = gEl('year');
    var subEl = gEl('sub_model');

    if (makeEl) {
      makeEl.addEventListener('change', function() {
        garageSel.make = this.value || null;
        garageSel.model = null;
        garageSel.year = null;
        garageSel.sub_model = null;
        disableSelect(yearEl, 'Select Year');
        disableSelect(subEl, 'Select Sub-Model');
        if (garageSel.make) {
          loadOptionsInto(modelEl, '/models', { make: garageSel.make }, 'models', 'Select Model');
        } else {
          disableSelect(modelEl, 'Select Model');
        }
        updateGarageSaveBtn();
      });
    }

    if (modelEl) {
      modelEl.addEventListener('change', function() {
        garageSel.model = this.value || null;
        garageSel.year = null;
        garageSel.sub_model = null;
        disableSelect(subEl, 'Select Sub-Model');
        if (garageSel.make && garageSel.model) {
          loadOptionsInto(yearEl, '/years', { make: garageSel.make, model: garageSel.model }, 'years', 'Select Year');
        } else {
          disableSelect(yearEl, 'Select Year');
        }
        updateGarageSaveBtn();
      });
    }

    if (yearEl) {
      yearEl.addEventListener('change', function() {
        garageSel.year = this.value || null;
        garageSel.sub_model = null;
        if (garageSel.make && garageSel.model && garageSel.year) {
          loadGarageSubModels();
        } else {
          disableSelect(subEl, 'Select Sub-Model');
        }
        updateGarageSaveBtn();
      });
    }

    if (subEl) {
      subEl.addEventListener('change', function() {
        garageSel.sub_model = this.value || null;
        updateGarageSaveBtn();
      });
    }
  }

  function initGarage() {
    var chip = document.getElementById('garage-chip');
    if (!chip) return;
    bindGarageEvents();
    renderGarageChip();
  }

  function init() {
    initGarage();

    var widget = getWidget();
    if (!widget) return;

    bindEvents();

    if (!isCartMode()) {
      document.addEventListener('change', function(e) {
        var target = e.target;
        if (target && target.name && target.name.indexOf('id') !== -1 && target.closest('[data-section-id]')) {
          var selectedOption = target.options ? target.options[target.selectedIndex] : null;
          if (selectedOption && selectedOption.dataset && selectedOption.dataset.sku) {
            widget.dataset.productSku = selectedOption.dataset.sku;
          }
          if (state.make && state.model && state.year) {
            validateFitment();
          }
        }
      });
    }

    var saved = loadVehicle();
    if (saved && saved.make) {
      restoreSaved();
    } else {
      loadMakes();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
